export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
export const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT
export const MAIL_ENDPOINT = process.env.REACT_APP_MAIL_ENDPOINT
export const NOTIFICATION_ENDPOINT = process.env.REACT_APP_NOTIFICATION_ENDPOINT

export const TURNSTILE = process.env.REACT_APP_CLOUDFLARE_TURNSTILE

export const CHAT_KEY = process.env.REACT_APP_CHAT_KEY

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY

export const HTTP_STATUS_INTERNAL_SERVER = 'INTERNAL_SERVER_ERROR'
export const HTTP_STATUS_CONFLICT = 'CONFLICT'
export const HTTP_STATUS_BAD_REQUEST = 'BAD_REQUEST'
export const HTTP_STATUS_OK = 'OK'
export const HTTP_STATUS_NOT_FOUND = 'NOT_FOUND'
export const HTTP_NO_CONTENT = 'NO_CONTENT'
export const HTTP_UNAUTHORIZED = 'UNAUTHORIZED'

export const SystemRole = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    USER_WITH_ROLE: 'user_with_role',
    USER: 'user',
}
